import { ResourcefulReducer } from '../../util';
import ACTIONS from '../actions';
import EntityModel from '../models/entity_model';

const ExportedEntityReducer = new ResourcefulReducer('exported_entities', EntityModel, {
  list: ACTIONS.LIST_EXPORTED_ENTITIES,
});

export default ExportedEntityReducer;
